// @ts-nocheck
export default function Differentiators() {
  return (
    <>
<div className="diff-section">

  <div className="diff-row dark">
    <div className="diff-text">
      <div className="diff-ey ey-d"><span aria-hidden="true" className="ey-dot"></span>The verification advantage</div>
      <h2 className="diff-h">
        <span className="dhw" style={{"animationDelay":".05s"}}>Built</span>{" "}
        <span className="dhw" style={{"animationDelay":".13s"}}>to</span>{" "}
        <em>
          <span className="dhw em-glow" data-letters="verify." style={{"animationDelay":".21s"}}>verify.</span>
        </em>
        {" "}<br />
        <span className="dhw" style={{"animationDelay":".29s"}}>Not</span>{" "}
        <span className="dhw" style={{"animationDelay":".37s"}}>to</span>{" "}
        <span className="dhw" style={{"animationDelay":".45s"}}>guess.</span>
      </h2>
      <p className="diff-p">
        Most AI tools state a citation and hope it&apos;s right. LexVio gives every one a verdict —
        {" "}<span className="hl">verified</span>,
        {" "}<span className="hl">ambiguous</span> or
        {" "}<span className="hl">unresolved</span>. A quote from your own documents is verified only when the words are there, with the page attached; a fact in a matter is kept only when its quote is found in the file. Analysis is grounded in the governing law the contract names. Not a near-match. Not a guess.
      </p>
      <a className="diff-link" href="/product/legal-ai">
        <span className="dl-text">See how verification works</span>
        <span aria-hidden="true" className="dl-arrow">→</span>
      </a>
    </div>
    <div className="diff-visual">
      <div aria-hidden="true" className="diff-scan"></div>
      <div className="dviz-stack" style={{"display":"flex","flexDirection":"column","gap":"6px","width":"100%","maxWidth":"320px"}}>
        <div className="dviz-eyebrow">What every answer is checked against</div>
        <div className="dviz-card diff-action diff-action-active" style={{"--idx":"0","borderLeft":"2px solid var(--cu)"}}>
          <div style={{"flex":"1"}}>
            <div className="dviz-label">Your own documents</div>
            <div className="dviz-val">Quoted words found in the source — page attached</div>
            <div className="dviz-bar"><div className="dviz-bar-fill" style={{"--w":"100%"}}></div></div>
          </div>
        </div>
        <div className="dviz-card diff-action" style={{"--idx":"1"}}>
          <div style={{"flex":"1"}}>
            <div className="dviz-label">The governing-law clause</div>
            <div className="dviz-val">Read from the whole contract — unknown is an answer</div>
            <div className="dviz-bar"><div className="dviz-bar-fill" style={{"--w":"100%","background":"var(--cl)"}}></div></div>
          </div>
        </div>
        <div className="dviz-card diff-action" style={{"--idx":"2"}}>
          <div style={{"flex":"1"}}>
            <div className="dviz-label">The matter&apos;s fact store</div>
            <div className="dviz-val">A fact without a quote in the file is dropped</div>
            <div className="dviz-bar"><div className="dviz-bar-fill" style={{"--w":"100%","background":"var(--cl)"}}></div></div>
          </div>
        </div>
        <div className="dviz-card diff-action" style={{"--idx":"3"}}>
          <div style={{"flex":"1"}}>
            <div className="dviz-label">Authorities you type in</div>
            <div className="dviz-val">Unverified until you ask for a check</div>
            <div className="dviz-bar"><div className="dviz-bar-fill" style={{"--w":"30%","background":"rgba(251,250,246,.45)"}}></div></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div className="diff-row flip">
    <div className="diff-text">
      <div className="diff-ey"><span aria-hidden="true" className="ey-dot"></span>One login, three modules</div>
      <h2 className="diff-h">
        <span className="dhw" style={{"animationDelay":".05s"}}>Everything</span>{" "}
        <span className="dhw" style={{"animationDelay":".15s"}}>connected.</span>
        {" "}<br />
        <em>
          <span className="dhw" style={{"animationDelay":".25s"}}>Nothing</span>{" "}
          <span className="dhw em-glow" data-letters="siloed." style={{"animationDelay":".35s"}}>siloed.</span>
        </em>
      </h2>
      <p className="diff-p">
        Read a matter&apos;s file → its facts feed the draft. Confirm a court order&apos;s direction → it becomes a task. Share a step with a client → their answer lands on the workflow. Flag a liability clause → see it in the contract&apos;s health card.{" "}
        <span className="hl">One platform where everything talks to everything else.</span>
      </p>
      <a className="diff-link" href="#bento">
        <span className="dl-text">Explore all modules</span>
        <span aria-hidden="true" className="dl-arrow">→</span>
      </a>
    </div>
    <div className="diff-visual" style={{"background":"var(--b100)"}}>
      <div className="diff-modules-viz">
        <svg aria-hidden="true" className="dmv-connector" preserveAspectRatio="none">
          <line x1="0" x2="0" y1="0" y2="100%" />
        </svg>
        <div className="dmv-item" style={{"--idx":"0"}}>
          <span className="dmv-num">01</span>
          <span className="dmv-name">Legal AI</span>
          <span className="dmv-tag">Core</span>
          <span aria-hidden="true" className="dmv-arrow">→</span>
          <span aria-hidden="true" className="dmv-pulse"></span>
        </div>
        <div className="dmv-item" style={{"--idx":"1"}}>
          <span className="dmv-num">02</span>
          <span className="dmv-name">Compliance AI</span>
          <span className="dmv-tag">Privacy</span>
          <span aria-hidden="true" className="dmv-arrow">→</span>
          <span aria-hidden="true" className="dmv-pulse"></span>
        </div>
        <div className="dmv-item" style={{"--idx":"2"}}>
          <span className="dmv-num">03</span>
          <span className="dmv-name">Workflow Agents</span>
          <span className="dmv-tag">Automation</span>
          <span aria-hidden="true" className="dmv-arrow">→</span>
          <span aria-hidden="true" className="dmv-pulse"></span>
        </div>
      </div>
    </div>
  </div>

  <div className="diff-row dark">
    <div className="diff-text">
      <div className="diff-ey ey-d"><span aria-hidden="true" className="ey-dot"></span>From insight to action</div>
      <h2 className="diff-h">
        <span className="dhw" style={{"animationDelay":".05s"}}>Not</span>{" "}
        <span className="dhw" style={{"animationDelay":".13s"}}>just</span>{" "}
        <span className="dhw" style={{"animationDelay":".21s"}}>analysis.</span>
        {" "}<br />
        <em>
          <span className="dhw em-glow em-big" data-letters="Action." style={{"animationDelay":".30s"}}>Action.</span>
        </em>
      </h2>
      <p className="diff-p">
        Every other platform gives you a PDF. LexVio gives you{" "}
        <span className="hl">redlines to send</span>,{" "}
        <span className="hl">fixes to apply</span>,{" "}
        <span className="hl">tasks to file</span>, and{" "}
        <span className="hl">client approvals to collect</span>. The platform doesn&apos;t stop at the report.
      </p>
      <a className="diff-link" href="/scan">
        <span className="dl-text">Try the free scanner</span>
        <span aria-hidden="true" className="dl-arrow">→</span>
      </a>
    </div>
    <div className="diff-visual">
      <div aria-hidden="true" className="diff-scan"></div>
      <div className="dviz-stack" style={{"display":"flex","flexDirection":"column","gap":"5px","width":"100%","maxWidth":"320px"}}>
        <div className="dviz-eyebrow">What you can do after analysis</div>
        <div className="diff-action diff-action-active" style={{"--idx":"0","borderLeft":"2px solid var(--cu)"}}>
          <div className="diff-action-dot diff-action-dot-pulse"></div>
          <span className="diff-action-text">Apply AI-generated redlines</span>
          <span aria-hidden="true" className="diff-action-arrow">→</span>
          <span aria-hidden="true" className="diff-action-sweep"></span>
        </div>
        <div className="diff-action" style={{"--idx":"1"}}>
          <div className="diff-action-dot" style={{"background":"var(--cl)"}}></div>
          <span className="diff-action-text">Share annotated draft</span>
          <span aria-hidden="true" className="diff-action-arrow">→</span>
        </div>
        <div className="diff-action diff-action-dim" style={{"--idx":"2"}}>
          <div className="diff-action-dot" style={{"background":"rgba(251,250,246,.5)"}}></div>
          <span className="diff-action-text">File a direction as a task</span>
          <span aria-hidden="true" className="diff-action-arrow">→</span>
        </div>
        <div className="diff-action diff-action-dim" style={{"--idx":"3"}}>
          <div className="diff-action-dot" style={{"background":"rgba(251,250,246,.5)"}}></div>
          <span className="diff-action-text">Send to the client for approval</span>
          <span aria-hidden="true" className="diff-action-arrow">→</span>
        </div>
        <div className="diff-action diff-action-dim" style={{"--idx":"4"}}>
          <div className="diff-action-dot" style={{"background":"rgba(251,250,246,.5)"}}></div>
          <span className="diff-action-text">Save to your matter</span>
          <span aria-hidden="true" className="diff-action-arrow">→</span>
        </div>
      </div>
    </div>
  </div>
</div>


    </>
  );
}
